import React from 'react';
import styled from 'styled-components';
import { translate } from 'base/shared/Localization';

const Container = styled.div`
  width: 100%;
  margin-top: 8px;
`;

const Title = styled.h2`
  font-family: 'modelica', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  color: #1f2937;
  margin: 0 0 24px 0;
  padding: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const SummaryCard = styled.div`
  background: #f5f7fa;
  padding: 32px;
  border-radius: 16px;
`;

const DateSection = styled.div`
  margin-bottom: ${(props) => (props.hasSubPayments ? '24px' : '10px')};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

const DateRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${(props) => (props.hasSubPayments ? '8px' : '0')};
`;

const DateText = styled.span`
  font-family: 'modelica', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  color: #1f2937;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const SubPaymentsList = styled.div`
  margin-top: 8px;
  margin-left: 16px;
`;

const SubPaymentItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SubPaymentText = styled.span`
  font-family: 'modelica', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.2;
  color: #4b5563;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const GrandTotalSection = styled.div`
  margin-top: 32px;
  padding-top: 32px;
  border-top: 1px solid lightgrey;
`;

const GrandTotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const GrandTotalLabel = styled.span`
  font-family: 'modelica', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  color: #111827;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const GrandTotalAmount = styled.span`
  font-family: 'modelica', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  color: #111827;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const BookingSummaryCard = ({ paymentsBreakdown, title }) => {
  if (!paymentsBreakdown?.installments?.payments) {
    return null;
  }

  const finalTitle = title == false ? null : title || translate('booking.summary.title');
  const { installments, total } = paymentsBreakdown;

  return (
    <Container>
      {!!finalTitle && <Title>{finalTitle}</Title>}

      <SummaryCard>
        {/* Payment installments */}
        {installments.payments.map((payment, index) => {
          const hasSubPayments = payment.sub_payments && payment.sub_payments.length > 1;

          return (
            <DateSection key={index} hasSubPayments={hasSubPayments}>
              {/* Date Header with Total on same row */}
              <DateRow hasSubPayments={hasSubPayments}>
                <DateText>{payment.title}</DateText>
                <DateText>{payment.total}</DateText>
              </DateRow>

              {/* Sub-payments */}
              {hasSubPayments && (
                <SubPaymentsList>
                  {payment.sub_payments.map((subPayment, subIndex) => (
                    <SubPaymentItem key={subIndex}>
                      <SubPaymentText>• {subPayment.title}</SubPaymentText>
                      <SubPaymentText>{subPayment.amount}</SubPaymentText>
                    </SubPaymentItem>
                  ))}
                </SubPaymentsList>
              )}
            </DateSection>
          );
        })}

        {/* Grand Total */}
        {total && (
          <GrandTotalSection>
            <GrandTotalRow>
              <GrandTotalLabel>Total:</GrandTotalLabel>
              <GrandTotalAmount>{total}</GrandTotalAmount>
            </GrandTotalRow>
          </GrandTotalSection>
        )}
      </SummaryCard>
    </Container>
  );
};

export default BookingSummaryCard;
